import { gql } from '@apollo/client';

const NEW_GROUP_FRAGMENT = gql`
  fragment NewGroup on Group {
    id
    name
    color
    folderId
    createdAt
    updatedAt
  }
`;

export default NEW_GROUP_FRAGMENT;
